import { render, staticRenderFns } from "./CustomFieldsSettings.vue?vue&type=template&id=78ba519e&"
import script from "./CustomFieldsSettings.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports